import { defaultInteractionOptions } from "@common/components/helpers/options/interactionOptions";
import BaseReducer from "./BaseReducer";

class CustomerFormReducer extends BaseReducer {
  domain = "CustomerForm";
  type = "View";

  initialState = {
    formType: "",
    rowVersion: null,
    // Loading flag for the Select component
    loadingCustomers: false,
    // The raw API response for searching a customer
    customersResponse: [],
    // The options for the Search Customer dropdown list fetch from backend API
    customersOptions: [],
    unselectedCustomerOptions: [],
    // The customer input that is populated in the Search Customer search box
    searchedCustomer: null,
    // The customer/customers that are selected for form submission
    customers: null,
    // Options for the customer interaction reasons
    customerInteractionOptions: defaultInteractionOptions,

    hasPhoneOrEmail: false,
  };
}

const reducer = new CustomerFormReducer();

export default reducer;
